import API from "../../util/api";

const BASE = "/company/statistics";

export default {
  getStatistic(payload) {
    return API.get(BASE, { params: payload });
  },
  // 상단 왼쪽 특허 통계
  getPatentMainStatistic(payload) {
    return API.get(`${BASE}/patent/main`, { params: payload });
  },

  /** @deprecated 특사도 getPatentMainStatistic — x-company-idx 헤더로 고객사 전달 */
  getPatentMainStatisticAgent(company_idx, payload) {
    return this.getPatentMainStatistic(payload);
  },

  // 상단 오른쪽 상표 통계
  getTrademarkMainStatistic(payload) {
    return API.get(`${BASE}/trademark/main`, { params: payload });
  },

  // 상단 오른쪽 디자인 통계
  getDesignMainStatistic(payload) {
    return API.get(`${BASE}/design/main`, { params: payload });
  },

  // 하단 왼쪽 연차료 통계
  getAnnualPayMainStatistic(payload) {
    return API.get(`${BASE}/annualpay/main`, { params: payload });
  },
  // 하단 오른쪽 그래프 통계
  getGraphMainStatistic(payload) {
    return API.get(`${BASE}/graph/main`, { params: payload });
  },
  /** @deprecated 특사도 getStatistic — x-company-idx 헤더로 고객사 전달 */
  getStatisticAgent(company_idx, payload) {
    return this.getStatistic(payload);
  },
  getStatisticPaymentHistory() {
    return API.get(`/test/statistic/paymentHistory`);
  },
  getStatisticTemplateTradeHistory() {
    return API.get(`/test/statistic/templateTradeHistory`);
  },
  insertPaymentHistory(payload) {
    return API.post("/test/statistic/paymentHistory", payload);
  },
  deletePaymentHistory(payload) {
    return API.delete("/test/statistic/paymentHistory", { data: payload });
  },
  getPatentByYear(payload) {
    return API.get("/common/statistics/getPatentByYear", { params: payload });
  },
  getRightTransfer(payload) {
    return API.get("/common/statistics/getRightTransfer", { params: payload });
  },
  getTechEval(payload) {
    return API.get("/common/statistics/getTechEval", { params: payload });
  },
  getAlive(payload) {
    return API.get("/common/statistics/getPatentAlive", { params: payload });
  },
  getPatentNation(payload) {
    return API.get("/common/statistics/getPatentNation", { params: payload });
  },
  getAnnualPayData(payload) {
    return API.get("/common/statistics/getAnnualPayData", { params: payload });
  },
};
